import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

function Skills() {
  return (
    <div
      className="bg-blue w-full h-full lg:px-16 px-7 overflow-x-hidden font-poor-story text-white lg:text-2xl md:text-lg text-base leading-loose tracking-widest"
      data-aos="fade-right"
      data-aos-easing="ease-in-sine"
      data-aos-duration="400">
      {/* NAVBAR */}
      <Navbar
        pageTitle="Skills"
        data-aos="fade-right"
        data-aos-easing="ease-in-sine"
        data-aos-duration="500"
      />

      {/* LANGUAGES & FRAMEWORKS */}
      <div
        className="mt-24 flex flex-col gap-7"
        data-aos="fade-right"
        data-aos-easing="ease-in-sine"
        data-aos-duration="600">
        <h1 className="md:text-3xl text-2xl mb-10">Languages & Frameworks</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="flex gap-2 items-center">
            <img
              src={require("../assets/icons/html.png")}
              alt="html icon"
              className="w-14 mr-3"
            />
            <p className="text-2xl">HTML</p>
          </div>
          <div className="flex gap-2 items-center">
            <img
              src={require("../assets/icons/css.png")}
              alt="html icon"
              className="w-14 mr-3"
            />
            <p className="text-2xl">CSS</p>
          </div>
          <div className="flex gap-2 items-center">
            <img
              src={require("../assets/icons/sass.png")}
              alt="html icon"
              className="w-14 mr-3"
            />
            <p className="text-2xl">SASS (SCSS)</p>
          </div>
          <div className="flex gap-2 items-center">
            <img
              src={require("../assets/icons/bootstrap.png")}
              alt="html icon"
              className="w-14 mr-3"
            />
            <p className="text-2xl">Bootstrap</p>
          </div>
          <div className="flex gap-2 items-center">
            <img
              src={require("../assets/icons/tailwind.png")}
              alt="html icon"
              className="w-14 mr-3"
            />
            <p className="text-2xl">Tailwind</p>
          </div>
          <div className="flex gap-2 items-center">
            <img
              src={require("../assets/icons/javascript.png")}
              alt="html icon"
              className="w-14 mr-3"
            />
            <p className="text-2xl">JavaScript - ES6</p>
          </div>
          <div className="flex gap-2 items-center">
            <img
              src={require("../assets/icons/vue.png")}
              alt="html icon"
              className="w-14 mr-3"
            />
            <p className="text-2xl">Vue</p>
          </div>
          <div className="flex gap-2 items-center">
            <img
              src={require("../assets/icons/react.png")}
              alt="html icon"
              className="w-14 mr-3"
            />
            <p className="text-2xl">React</p>
          </div>
        </div>
      </div>

      {/* TOOLS & PACKAGES */}
      <div
        className="mt-32 flex flex-col gap-7"
        data-aos="fade-right"
        data-aos-easing="ease-in-sine"
        data-aos-duration="700">
        <h1 className="md:text-3xl text-2xl mb-10">Tools & Packages</h1>
        <div className="flex justify-evenly md:justify-between items-center flex-wrap gap-4">
          <div className="flex gap-2 items-center">
            <img
              src={require("../assets/icons/npm.png")}
              alt="npm icon"
              className="w-28 mr-3"
            />
          </div>
          <div className="flex gap-2 items-center">
            <img
              src={require("../assets/icons/axios.png")}
              alt="html icon"
              className="w-28 mr-3"
            />
          </div>
          <div className="flex gap-2 items-center">
            <img
              src={require("../assets/icons/json.png")}
              alt="html icon"
              className="w-28 mr-3"
            />
          </div>
          <div className="flex gap-2 items-center">
            <img
              src={require("../assets/icons/git.png")}
              alt="html icon"
              className="w-24 mr-3"
            />
          </div>
          <div className="flex gap-2 items-center">
            <img
              src={require("../assets/icons/github.png")}
              alt="html icon"
              className="w-16 mr-3"
            />
          </div>
        </div>
      </div>

      {/* FOOTER */}
      <Footer />
    </div>
  );
}

export default Skills;
